export const filtersList = [
    {
        name: "wifi",
        label: 'amenities.wifi'
    },
    {
        name: 'parkingAssigned',
        label: 'amenities.parking'
    },
    {
        name: 'meta[tv]',
        label: 'amenities.tv'
    },
    {
        name: 'meta[tv_kanaly_niemieckie]',
        label: 'amenities.german-channels'
    },
    {
        name: 'meta[akcesoria-kuchenne]',
        label: 'amenities.kitchen-accessories'
    },
    {
        name: 'meta[lodowka]',
        label: 'amenities.fridge'
    },
    {
        name: 'meta[piekarnik]',
        label: 'amenities.oven'
    },
    {
        name: 'meta[plyta-kuchenna]',
        label: 'amenities.stovetop'
    },
    {
        name: 'meta[czajnik]',
        label: 'amenities.kettle'
    },
    {
        name: 'meta[mikrofalowka]',
        label: 'amenities.microwave-oven'
    },
    {
        name: 'meta[zmywarka]',
        label: 'amenities.dishwasher'
    },
    {
        name: 'meta[ekspres-do-kawy]',
        label: 'amenities.coffee-maker'
    },
    {
        name: 'meta[pralka]',
        label: 'amenities.washing-machine'
    },
    {
        name: 'meta[klimatyzacja]',
        label: 'amenities.air-condition'
    },
    // {
    //     name: 'meta[kawiarnia-w-budynku]',
    //     label: 'amenities.cafe-in-building'
    // },
    {
        name: 'meta[akceptujemy-zwierzeta]',
        label: 'amenities.animals'
    },
    // {
    //     name: 'meta[klub-dyskoteka-w-budynku]',
    //     label: 'amenities.club-in-building'
    // },
    // {
    //     name: 'meta[sauna]',
    //     label: 'amenities.sauna-premises'
    // },
    // {
    //     name: 'meta[jacuzzi-w-obiekcie]',
    //     label: 'amenities.jacuzzi-premises'
    // },
    {
        name: 'meta[jacuzzi-zewnetrzne-na-tarasie]',
        label: 'amenities.jacuzzi-outdoor-summer'
    },
    {
        name: 'meta[basen-w-obiekcie]',
        label: 'amenities.swimming-pool-premises'
    },
    {
        name: 'meta[basen-zewnetrzny-w-obiekcie]',
        label: 'amenities.outdoor-swimming-pool-premises'
    },
]

export const DEFAULT_FILTERS = {
    priceMin: null,
    priceMax: null,
    roomMin: null,
    roomMax: null,
    parkingAssigned: null,
    pets: null,
    wifi: null,
    'meta[hotelowa-posciel]': true,
    'meta[hotelowa-posciel-i-reczniki]': true,
}

